import React from "react";

const SelectedTeamContext = React.createContext({});

export default SelectedTeamContext;
